// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-layouts----Footer-module---footer---2ss7M","link-container-column":"src-layouts----Footer-module---link-container-column---QzRuq","login-column":"src-layouts----Footer-module---login-column---1_Xj3"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Footer.module.scss
// module id = 666
// module chunks = 114276838955818